export function mark(needle, haystack) {
    let needleIndex = haystack.search(new RegExp(escapeRegex(needle), "gi"));

    if (needleIndex >= 0) {
        let find = haystack.substr(needleIndex, needle.length);
        return haystack.replaceAll(
            new RegExp(escapeRegex(needle), "gi"),
            `<span class="highlighted">${find}</span>`
        );
    }

    return haystack;
}

export function truncateString(str, num) {
    if (!str) return;

    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
}

function escapeRegex(string) {
    return string.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
}
